import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  CreateTriggerRequestDto,
  TriggerResponseDto,
} from '@evimo/client/models';
import { PreventiveMaintenanceService } from '~/app/services/preventive-maintenance/preventive-maintenance.service';

export function useTriggers() {
  return useQuery({
    queryKey: ['preventive-maintenance', 'triggers'] as const,
    queryFn: async (): Promise<TriggerResponseDto[]> => {
      const res = await PreventiveMaintenanceService.listTriggers();
      return res.data;
    },
  });
}

export function useCreateTrigger() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateTriggerRequestDto) =>
      PreventiveMaintenanceService.createTrigger(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['preventive-maintenance', 'triggers'],
      });
    },
  });
}
